import { createSelector } from 'reselect';

const getSiteIndexedMappings = (state) => state.geometryMappings.mappingsBySite;
const getSiteIndexedGeometries = (state) => state.geometryMappings.geometriesBySiteAndModel;
export const getMappingsImported = (state) => state.geometryMappings.mappingsImportedAt;

export const getIndexedMappingsBySite = createSelector(
  [(_, siteId) => siteId, getSiteIndexedMappings, getSiteIndexedGeometries],
  (siteId, mappingsBySite, geometriesBySiteAndModel) => {
    if (mappingsBySite[siteId]) {
      const siteGeometries = Object.values(geometriesBySiteAndModel?.[siteId] || {}).flat();
      const indexedMappings = {};
      for (const [key, { geometryIds, ...mapping }] of Object.entries(
        mappingsBySite[siteId].mappings
      )) {
        indexedMappings[key] = {
          ...mapping,
          objects: geometryIds
            .map((id) => siteGeometries.find((geometry) => geometry.id === id))
            .filter((geometry) => !!geometry),
        };
      }

      return indexedMappings;
    }
    return null;
  }
);

export const getModelAndDesignationIndexedMappingIdsBySite = createSelector(
  [(_, siteId) => siteId, getSiteIndexedMappings],
  (siteId, mappingsBySite) => {
    if (mappingsBySite[siteId]) {
      return mappingsBySite[siteId].modelAndDesignationToMappingId;
    }
    return null;
  }
);

export const getVersionMappings = createSelector(
  [
    (_, siteId, modelId, versionId) => [siteId, modelId, versionId],
    getSiteIndexedMappings,
    getSiteIndexedGeometries,
  ],
  ([siteId, modelId, versionId], mappingsBySite, geometriesBySiteAndModel) => {
    const { ids = [], mappings = {} } = mappingsBySite[siteId] || {};
    const modelGeometries = geometriesBySiteAndModel?.[siteId]?.[modelId] || [];
    return ids
      .map((mappingId) => {
        const mapping = mappings[mappingId];
        return {
          ...mapping,
          objects: mapping.geometryIds
            .map((geometryId) => modelGeometries.find((geometry) => geometry.id === geometryId))
            .filter((geometry) => !!geometry),
        };
      })
      .filter((mapping) => mapping.version_id === versionId);
  }
);

export const getModelGeometries = createSelector(
  [(_, siteId, modelId) => [siteId, modelId], getSiteIndexedGeometries],
  ([siteId, modelId], geometriesBySiteAndModel) =>
    geometriesBySiteAndModel?.[siteId]?.[modelId] || []
);

export const getImportErrors = (state) => state.geometryMappings.importErrors;
